import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';

const ROLES = require('../../../../../server/shared/constants/role.constant');

interface PersonState {
  user?: { role?: string };
}

@Injectable()
export class AppAdminGuard implements CanActivate {
  constructor(private store: Store<{ PERSON_REDUCER: PersonState }>, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.store
        .select<PersonState>('PERSON_REDUCER')
        .map((s) => s.user)
        .filter((user) => !!user)
        .take(1)
        .subscribe((user) => {
          if (user && (user.role === ROLES.ROLE_APP_ADMIN || user.role === ROLES.ROLE_UCOP_ADMIN)) {
            resolve(true);
          } else {
            this.router.navigate(['']);
            resolve(false);
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/guard/app-admin.guard.ts